import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-area",
  "use": "icon-area-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-area\"><path d=\"M544 480L64 64s55 764 54.857 768C125 926 177 960 256 960c2 0 574-52 576-52.217C933 899 960 832 960 768V127L544 480z m352 284c0 33-4.341 50.932-25 67-18 14-75 16-75 16l-541 49c-28 0-42.909-4.744-53-13-22-18-21-82-21-82l-42-587 348 301c25 21 32 28 58 29 31.976 1.23 62-34 62-34l289-245v499z\" p-id=\"11501\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol